import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 md:gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-primary-600 mb-2">
            <span className="w-4 h-px bg-primary-400"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-[28px] leading-tight font-semibold text-foreground-950">
          {title}
        </h2>
        {desc && <p className="text-xs md:text-sm leading-6 text-foreground-600 mt-2 max-w-2xl">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 h-9 px-4 rounded-md border border-background-300 text-xs md:text-sm text-foreground-700 flex items-center gap-1.5 whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}